<template>
  <div class="sub-tab">
    <el-radio-group v-model="localValue" @input="onInputChange">
      <el-radio-button
        v-for="(option, index) in options"
        :key="index"
        :label="option.value"
        :disabled="option.disabled"
        >
        {{ option.label }}
      </el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "subTab",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabledOptions: {
      type: Array,
      default: () => [],
    },
    isIndex: {
      tyoe: Boolean,
      default: false,
    }
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  methods: {
    onInputChange(newValue) {
      this.$emit("input", newValue);
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.sub-tab {
  ::v-deep .el-radio-group {
    padding: 4px;
    background: #f5f5f7;
    border-radius: 4px;
  }

  ::v-deep .el-radio-button__inner {
    border-color: #f5f5f7;
    box-shadow: none;
    color: #666666;
    background-color: rgba(0, 0, 0, 0);
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #333333;
    background: white;
    border-radius: 4px;
  }
}
</style>
